import React, {Component} from 'react'
import { Alert } from "react-bootstrap"
import Select from "react-select3"
import PropTypes from 'prop-types'
import request from 'superagent'
import _ from 'lodash'

export default class SharepointDriveSelector extends Component {
  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    siteId: PropTypes.string,
    onSelectDrive: PropTypes.func,
    defaultValue: PropTypes.object,
  };

  static defaultProps = {
    connectionId: null,
    siteId: null,
    onSelectDrive: null,
  };

  state = {
    drives: [],
    selectedDrive: null,
  };

  componentDidMount() {
    this.setState({selectedDrive: this.props.defaultValue});
    this.loadSharePointDrives();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // refresh drives list when siteId prop changes
    if (prevProps.siteId !== this.props.siteId) {
      this.setState({selectedDrive: null});
      this.loadSharePointDrives();
    }
  }

  loadSharePointDrives(forceRefresh) {
    this.setState({ isLoading: true, isError: false });

    const { connectionId, siteId } = this.props;

    request.get(`/rpc/integrations/connections/${connectionId}/sharepoint/sites/${siteId}/drives`)
      .query({ refresh: forceRefresh })
      .then(res => {
        const drives         = res.body.drives || [];
        const hasSingleDrive = drives.length === 1;

        this.setState({
          selectedDrive: hasSingleDrive ? drives[0] : this.state.selectedDrive,
          isLoading: false,
          drives
        });

        // If we selected the drive, also call the onSelectDrive handler
        if (hasSingleDrive && this.props.onSelectDrive)
          this.props.onSelectDrive(drives[0]);
      })
      .catch(error => {
        this.setState({ isLoading: false, isError: true  });
      });
  }

  render() {
    if (this.state.isError)
      return <Alert>Unable to load SharePoint Drives for Site</Alert>;

    const values = this.state.drives;
    const {selectedDrive} = this.state;

    return (
      <div style={{position: 'relative'}}>
        <Select
          value={this.state.selectedDrive}
          label={_.get(selectedDrive, 'name')}
          isLoading={this.state.isLoading}
          options={values}
          key={this.props.siteId}
          getOptionLabel={value => value.name}
          getOptionValue={value => value.id}
          onChange={selectedDrive => {
            this.setState({selectedDrive});

            if (this.props.onSelectDrive) this.props.onSelectDrive(selectedDrive)
          }}
        />
        {!this.state.isLoading &&
          <i className="fa fa-refresh"
             style={{
               position: 'absolute',
               textAlign: 'center',
               top: '13px',
               right: '75px',
               zIndex: 100,
               cursor: 'pointer'
             }}
             onClick={() => {
               !this.state.isLoading && this.loadSharePointDrives(true);
             }}
             key="site-refresh-button"
          />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/SharepointDriveSelector.jsx